module.exports = __webpack_public_path__ + "static/media/SeroLogo.f32d5a19.png";